import * as angular from "angular";
import {IController, IRootScopeService} from "angular";
import * as _ from "lodash"
import {BringozApi} from "../../../persistence-layer/models/bringoz-api.model";

export class CompleteSelectedTasksDialogCtrl implements IController {
  selectedTasks: any;
  allTasks: any;

  private submitted: boolean;

  constructor(private $scope, public $mdDialog, private tasksAPI: BringozApi, private $task, private $rootScope: IRootScopeService) {
  }

  $onInit() {
    this.submitted = false;
  }

  confirm() {
    this.submitted = true;
    this.$task().$call(this.tasksAPI.actions.complete, {
      ids: this.selectedTasks
    })
      .then(() => {
        // _.forEach($scope._selectedTasks, function(selectedTask) {
        //     var tasksRemove = _.findIndex($scope._allTasks, function(task: TaskModel) {
        //         return _.isEqual(task, selectedTask)
        //     });
        //     if (!_.isEqual(tasksRemove, -1)) {
        //         $scope._allTasks.splice(tasksRemove, 1);
        //     }
        // });
        if (!_.isEmpty(this.allTasks)) {


          this.$task().$getAll({
            ids: this.allTasks
          })
            .then((updatedAllTasks) => {
                this.allTasks = updatedAllTasks;
                this.submitted = false;
                this.$rootScope.$emit('clear-selected-tasks');
                this.$mdDialog.hide();
              },
              () => {
                this.submitted = false;
                this.$rootScope.$emit('clear-selected-tasks');
                this.$mdDialog.hide();
              });
        } else {
          this.$scope.submitted = false;
          this.$rootScope.$emit('clear-selected-tasks');
          this.$mdDialog.hide();
        }
      })
  }
}

angular
  .module('bringoz.admin.tasks')
  .component('completeSelectedTasksDialog', {
    bindings: {
      selectedTasks: '<',
      allTasks: '<'
    },
    template: require('./complete-selected-tasks-dialog.html').default,
    controller: CompleteSelectedTasksDialogCtrl
  });
